module.exports = __webpack_public_path__ + "img/direction-arrow-off.92d6ebc5.svg";